import { ColumnSection, PageDsl, PageHeading } from '../../types';
import { PageSettingsManager } from '../settings';

export const shouldDisableGroupAnalyticsSharing = () => {
  const pageSettings = PageSettingsManager.getInstance().get();
  const groups = pageSettings?.__page__.lbGroups || pageSettings?.__page__.plGroups || [];
  const groupNames = groups.map(group => group.split('|')[0]) || [];
  const isGroupChosen = pageSettings?.__page__.ids?.some(id => groupNames.includes(id));
  return isGroupChosen;
};

/**
 * Determines whether the filter tray should be disabled based on the provided PageDsl.
 * @param dsl - The PageDsl that contains the values needed
 * @returns A boolean indicating whether the filter tray should be disabled
 */
export const shouldDisableFilterTray = (dsl: PageDsl): boolean => {
  if (!dsl) {
    return false;
  }
  return getValueFromSections(dsl, 'isFilterDisabled') || getValueFromHeading(dsl, 'isFilterDisabled');
};

/**
 * Determines whether the copy link should be disabled based on the provided PageDsl.
 * @param dsl - The PageDsl that contains the values needed
 * @returns A boolean indicating whether the copy link should be disabled
 */
export const shouldDisableCopyLink = (dsl: PageDsl): boolean => {
  if (!dsl) {
    return false;
  }
  return getValueFromHeading(dsl, 'isCopyLinkDisabled');
};

const getValueFromSections = (dsl: PageDsl, key: string): boolean => {
  const columnSections = dsl.sections as ColumnSection[];
  if (!columnSections || columnSections.length === 0) {
    return false;
  }
  const columns = columnSections[0].columns;
  if (!columns || columns.length === 0) {
    return false;
  }
  return columns[0].component.heading?.[key] ?? false;
};

const getValueFromHeading = (dsl: PageDsl, key: string): boolean => {
  const heading = dsl.heading as unknown as PageHeading[];
  return heading[key] ?? false;
};
